import React, { useState, useEffect } from "react";
import { BgColorsOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import { useIntl } from "react-intl";
import IntlMessages from "@util/IntlMessages";
import { Message, Button, Input, Spin, Divider } from "../../../BP2Components";
import "./kanbanSettings.less";
import { KanbanScripts } from "../../DefaultWidgets/KanbanWidget/KanbanScripts";
import { Icon_Trash } from "../../../BP2Components/Icons/icons";
import SuperSelect from "../../../SuperSelect/SuperSelect.jsx";

const { validColumnsForHorizontalPlacement } = KanbanScripts;

const ColorSettings = ({ value, columns, renderedColumns }) => {
   const dispatch = useDispatch();
   const intl = useIntl();
   const [loading, setLoading] = useState(true);
   const [settings, setSettings] = useState({ ...value });
   const [columnColors, setColumnColors] = useState([]);
   const [itemsColors, setItemsColors] = useState([...value.verticalPlacementSettings]);

   //TODO: Make this useEffect more efficient
   useEffect(() => {
      if (
         renderedColumns?.length > 0 ||
         settings.horizontalPlacementSettings?.find(
            (item) => item?.columnTechName === settings.horizontalPlacement
         )
      ) {
         setLoading(false);
      }
      if (
         settings.horizontalPlacementSettings?.find(
            (item) => item?.columnTechName === settings.horizontalPlacement
         )
      ) {
         setColumnColors(
            settings?.horizontalPlacementSettings
               .find((item) => item.columnTechName === settings.horizontalPlacement)
               .colors.map(({ label, columnColor }) => ({ label, columnColor }))
         );
      } else {
         setColumnColors(
            renderedColumns?.map((item) => {
               return {
                  label: item[1]?.name,
                  columnColor: ""
               };
            })
         );
      }
   }, []);

   const handleSubmit = (e) => {
      e.preventDefault();
      const horizontalPlacementSettings = [
         ...value.horizontalPlacementSettings?.filter(
            (item) =>
               columns.find(({ techName }) => techName === item.columnTechName) &&
               item.columnTechName !== settings.horizontalPlacement
         ),
         {
            columnTechName: settings.horizontalPlacement,
            colors: columnColors
         }
      ];

      const verticalPlacementSettings = [...itemsColors.filter((item) => !!item.color)];
      setSettings({
         ...settings,
         horizontalPlacementSettings: horizontalPlacementSettings,
         verticalPlacementSettings: verticalPlacementSettings
      });

      dispatch(
         setWidgetInSheetParams({
            ...settings,
            horizontalPlacementSettings: horizontalPlacementSettings,
            verticalPlacementSettings: verticalPlacementSettings
         })
      );
      Message.success(intl.formatMessage({ id: "global.saved" }));

   };

   const pickColorForColumns = (e) => {
      const newColors = [...columnColors];
      newColors.find((item) => item.label === e.target.name).columnColor = e.target.value;
      setColumnColors(newColors);
   };

   const unPickColorForColumns = (labelName) => {
      const newColors = [...columnColors];
      newColors.find((item) => item.label === labelName).columnColor = "";
      setColumnColors(newColors);
   };

   const addNewItem = () => {
      setItemsColors((prevState) => [
         ...prevState,
         {
            columnTechName: validColumnsForHorizontalPlacement(columns)[0].techName,
            rowLabel: Object.values(validColumnsForHorizontalPlacement(columns)[0].values[0])[0],
            color: ""
         }
      ]);
   };

   const updateColorForItem = (e, type, index) => {
      const items = [...itemsColors];

      if (type === "column") {
         items[index].columnTechName = e.value;
         items[index].rowLabel = Object.values(
            columns.find((column) => column.techName === e.value)?.values?.[0]
         )[0];
      }

      if (type === "row") {
         items[index].rowLabel = e.label;
      }

      if (type === "color") {
         items[index].color = e;
      }

      setItemsColors(items);
   };

   const deleteItem = (index) => {
      const items = [...itemsColors];
      items.splice(index, 1);
      setItemsColors(items);
   };

   const getValuesForRows = (item) => {
      return columns
         ?.find((column) => column?.techName === item?.columnTechName)
         ?.values?.map((value) => ({
            value: Object.keys(value)[0],
            label: Object.values(value)[0]
         }));
   };

   return (
      <>
         <form
            onSubmit={handleSubmit}
            className="kanban-settings-container padding-left-15"
         >
            <div className="padding-left-15">
               <div key="globalSettings" >
                  <Divider plain>
                     <IntlMessages id="settings.colorsForItems" />
                  </Divider>
                  {itemsColors.map((item, index) => (
                     <>
                        <div className="color_settings-item_color-container colors-list">
                           <SuperSelect
                              handleSelect={(e) => updateColorForItem(e, "column", index)}
                              defaultValue={{
                                 value: item.columnTechName,
                                 label: validColumnsForHorizontalPlacement(columns)?.find(
                                    (column) => column.techName === item.columnTechName
                                 )?.title
                              }}
                              options={validColumnsForHorizontalPlacement(columns)?.map(
                                 (column) => ({
                                    value: column.techName,
                                    label: column.title
                                 })
                              )}
                           />
                           <SuperSelect
                              handleSelect={(e) => updateColorForItem(e, "row", index)}
                              defaultValue={{
                                 label: item.rowLabel,
                                 value: getValuesForRows(item)?.find(
                                    (option) => option.label === item?.rowLabel
                                 )?.value
                              }}
                              size={"small"}
                              isMulti={false}
                              closeMenuOnSelect={true}
                              options={getValuesForRows(item)}
                           />
                           <div className="colors-item-wrapper">
                              <div className="colors-item__picker">
                                 <input
                                    className={"wheel" + (!item.color ? " no-picked" : "")}
                                    type="color"
                                    onChange={(e) =>
                                       updateColorForItem(e.target.value, "color", index)
                                    }
                                    value={item.color || "#ffffff"}
                                 />
                                 {!item.color && <BgColorsOutlined className="icon-pipette" />}
                              </div>
                              {!!item.color && (
                                 <Button
                                    buttonType="link"
                                    className="button-reset-color"
                                    onClick={() => updateColorForItem("", "color", index)}
                                 >
                                    <i className="icon icon-close p1" />
                                 </Button>
                              )}
                           </div>
                           <Button
                              onClick={() => deleteItem(index)}
                              buttonType="danger"
                              className="button-delete-color-item"
                           >
                              <Icon_Trash stroke="none" fill="#eee" />
                           </Button>
                        </div>
                        <Divider />
                     </>
                  ))}
                  <Button onClick={() => addNewItem()} disabled={loading}>
                     <IntlMessages id="settings.addColor" />
                  </Button>
                  <Divider plain>
                     <IntlMessages id="settings.colorsForColumns" />
                  </Divider>
                  <label
                     key="horizontalPlacement"
                     className="widget-settings__inner__label"
                  >
                     <IntlMessages id="settings.horizontalPlacement" />:
                     <Input
                        item="horizontalPlacement"
                        defaultValue={
                           columns?.find((item) => item.techName === value?.horizontalPlacement)
                              ?.title
                        }
                        disabled
                     />
                  </label>

                  {!loading ? (
                     <div key="columnColors" label={<IntlMessages id="settings.colors" />}>
                        <div className="colors-list">
                           {columnColors.map((item) => {
                              return (
                                 <div className="colors-item">
                                    <label className="colors-item__label" for={item?.label}>
                                       {item?.label}
                                    </label>
                                    <div className="colors-item__picker">
                                       <input
                                          className={
                                             "wheel" + (!item.columnColor ? " no-picked" : "")
                                          }
                                          type="color"
                                          name={item?.label}
                                          onChange={pickColorForColumns}
                                          value={item?.columnColor || "#ffffff"}
                                       />
                                       {!item.columnColor && (
                                          <BgColorsOutlined className="icon-pipette" />
                                       )}
                                    </div>
                                    {!!item.columnColor && (
                                       <Button
                                          buttonType="link"
                                          className="button-reset-color"
                                          onClick={() => unPickColorForColumns(item?.label)}
                                       >
                                          <i className="icon icon-close p1" />
                                       </Button>
                                    )}
                                 </div>
                              );
                           })}
                        </div>
                     </div>
                  ) : (
                     <Spin />
                  )}
                     <Button
                        key="btn"
                        buttonType="primary"
                        htmlType="submit"
                        className="kanban-settings-save"
                     >
                        <IntlMessages id="global.preview" />
                     </Button>
               </div>
            </div>
         </form>
      </>
   );
};

export default ColorSettings;
